import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Ressult() {
  return (
    <section className="intro_section p-100">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={5} xl={5} xxl={5} className="my-auto">
            <h2 style={{ color: "#000" }}>
              The <span style={{ color: "#DB2F91" }}>Results</span>
            </h2>
            <p>
              We successfully implemented a system that solves one of the
              biggest problems faced by the gaming industry in the modern world.
              With an interactive UI and a complex rating system geared to
              provided nuanced information and reviews about up and coming games
              and gaming news. The result is a platform that reignites the lost
              trust between game developers, the review industry and gamers, all
              based on audience preferences and demands.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1 offset-lg-1"
          >
            <StaticImage
              src="../../../images/case-studies/button-smasher/result_img.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={783}
              height={911}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Ressult;
